import { render } from "./LateralBar.vue?vue&type=template&id=30cffeb5"
import script from "./LateralBar.vue?vue&type=script&lang=js"
export * from "./LateralBar.vue?vue&type=script&lang=js"

import "./LateralBar.vue?vue&type=style&index=0&id=30cffeb5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__